import { useRef } from "react";
import { RotateCcw } from "lucide-react";

const BG = "conic-gradient(from 90deg, #f00, #f0f, #00f, #0ff, #0f0, #ff0, #f00)";

export const ColourWheel = ({ label, value, onChange, testId }) => {
  const ref = useRef(null);
  const dragging = useRef(false);

  const setFrom = (e) => {
    const r = ref.current.getBoundingClientRect();
    let x = (e.clientX - r.left - r.width / 2) / (r.width / 2);
    let y = -(e.clientY - r.top - r.height / 2) / (r.height / 2);
    const m = Math.hypot(x, y);
    if (m > 1) { x /= m; y /= m; }
    onChange({ ...value, x: +x.toFixed(3), y: +y.toFixed(3) });
  };

  return (
    <div className="flex flex-col items-center gap-2" data-testid={testId}>
      <div className="flex items-center gap-1 w-full justify-between">
        <span className="text-[10px] uppercase font-mono-ui tracking-wider text-slate-400">{label}</span>
        <button onClick={() => onChange({ x: 0, y: 0, l: 0 })} className="text-slate-500 hover:text-[#FFB800]" data-testid={`${testId}-reset`}><RotateCcw className="w-3 h-3" /></button>
      </div>
      <div ref={ref} className="relative w-[84px] h-[84px] rounded-full cursor-crosshair touch-none border border-[#3F455A]"
        style={{ background: BG }}
        onPointerDown={(e) => { dragging.current = true; e.currentTarget.setPointerCapture(e.pointerId); setFrom(e); }}
        onPointerMove={(e) => dragging.current && setFrom(e)}
        onPointerUp={() => (dragging.current = false)}
        onDoubleClick={() => onChange({ ...value, x: 0, y: 0 })}
        data-testid={`${testId}-pad`}>
        <div className="absolute inset-0 rounded-full" style={{ background: "radial-gradient(circle, #2a2d38 0%, rgba(42,45,56,0.85) 35%, rgba(42,45,56,0.1) 100%)" }} />
        <div className="absolute w-px h-full left-1/2 bg-white/10" /><div className="absolute h-px w-full top-1/2 bg-white/10" />
        <div className="absolute w-3 h-3 -ml-1.5 -mt-1.5 rounded-full border-2 border-white bg-black/50 shadow-[0_0_8px_rgba(255,255,255,0.6)]"
          style={{ left: `${50 + value.x * 50}%`, top: `${50 - value.y * 50}%` }} />
      </div>
      <input type="range" min={-1} max={1} step={0.01} value={value.l} onChange={(e) => onChange({ ...value, l: +e.target.value })}
        className="mini w-[84px]" data-testid={`${testId}-luma`} />
      <span className="font-mono-ui text-[10px] text-slate-500" data-testid={`${testId}-readout`}>
        H{Math.round(((Math.atan2(value.y, value.x) * 180) / Math.PI + 360) % 360)}° S{Math.hypot(value.x, value.y).toFixed(2)} L{value.l >= 0 ? "+" : ""}{value.l.toFixed(2)}
      </span>
    </div>
  );
};
